import formatShort from "../../../utils/formatShort";

export default function SummaryNumber({ title, color, amount }: any) {
  return (
    <div className="mb-2">
      <div className="flex items-center">
        <div style={{ height: 20, width: 20, backgroundColor: `${color}` }}>
          .
        </div>
        <div className="ml-2">{title}</div>
      </div>
      <div className="font-bold text-black text-xl">{formatShort(amount)}</div>
    </div>
  );
}
